import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Button} from 'views/components';

import {Translate} from 'views/module';

const AuthDetail = (props) => {
  const caregiverAuth = props.caregiverAuth;
  const resetPassword = props.resetPassword;
  const reactivateAuth = props.reactivateAuth;
  const removeAuth = props.removeAuth;

  const user = caregiverAuth.user;
  const authData = caregiverAuth.authData;

  let status = 'RESET_REQUIRED';
  if (user.status === 'INACTIVE') {
    status = 'DEACTIVATED';
  } else if (authData?.[0]?.status) {
    status = authData?.[0]?.status;
  }

  const authActive = status === 'DEACTIVATED';

  return (
    <Stack spacing={2}>
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression="caregiver.CaregiverDetail.Settings.Auth.Email" />
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          {user.email}
        </Typography>
      </Stack>
      <Stack>
        <Typography
          sx={{
            fontWeight: 600,
          }}
        >
          <Translate expression="caregiver.CaregiverDetail.Settings.Auth.Status.Title" />
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
          }}
        >
          <Translate expression={`caregiver.CaregiverDetail.Settings.Auth.Status.${status}`} />
        </Typography>
      </Stack>
      {
        authActive &&
        <>
          <Stack>
            <Button
              onClick={reactivateAuth}
              sx={{
                mx: 2,
              }}
            >
              <Translate expression="caregiver.CaregiverDetail.Settings.Auth.ReactivateAuth" />
            </Button>
          </Stack>
        </>
      }
      {
        !authActive &&
        <>
          <Stack>
            <Button
              onClick={resetPassword}
              sx={{
                mx: 2,
              }}
            >
              <Translate expression="caregiver.CaregiverDetail.Settings.Auth.ResetPassword" />
            </Button>
          </Stack>
          <Stack>
            <Button
              onClick={removeAuth}
              sx={{
                mx: 2,
              }}
            >
              <Translate expression="caregiver.CaregiverDetail.Settings.Auth.RemoveAuth" />
            </Button>
          </Stack>
        </>
      }
    </Stack>
  );
};
AuthDetail.propTypes = {
  caregiverAuth: PropTypes.object.isRequired,
  removeAuth: PropTypes.func.isRequired,
  resetPassword: PropTypes.func.isRequired,
  reactivateAuth: PropTypes.func.isRequired,
};
export default React.memo(AuthDetail);
